import About from "./About";
import Clinicalsection from "./Clinicalsection";
import Currentposition from "./Currentposition";
import Ourjourney from "./Ourjourney";
import Stripsection from "./Stripsection";
import Videosection from "./Videosection";
import Header from './Header';
import Footer from './Footer';


export default function Homepage() {
    return (
        <>
            <Header />
            <About />
            <Ourjourney />
            <Currentposition />
            <Videosection />
            {/* <Clinicalsection /> */}
            <Stripsection />
            <Footer />
        </>
    )
}